import { AbstractControl } from "@angular/forms";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

declare let _ : any;
declare let moment : any;

export class DatePicker {
    after = (one: NgbDateStruct, two: NgbDateStruct) =>
        !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
            ? false : one.day > two.day : one.month > two.month : one.year > two.year;

     before = (one: NgbDateStruct, two: NgbDateStruct) =>
        !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
            ? false : one.day < two.day : one.month < two.month : one.year < two.year;

     dateStrToObj(ctrl: AbstractControl) {
        return _.isObject(ctrl.value)
            ? _.values(ctrl.value)
            : moment(ctrl.value).format('Y-MM-DD').split('-');
    }

     dateObjToStr(value) {
        return _.values(value).join('-');
    }

}